import { CombinedError, Operation } from 'urql';

const handleUrqlError = (error: CombinedError, operation?: Operation) => {
  console.error(error);
  console.error(operation);
};

export default handleUrqlError;
